/* for dynamic image generation in parcel */

import png from "url:../../portfolio/assets/*.png";
import jpg from "url:../../portfolio/assets/*.jpg";
import jpeg from "url:../../portfolio/assets/*.jpeg";
import webp from "url:../../portfolio/assets/*.webp";

const useDynamicImageGenerate = (image, isCover) => {
    const obj = Object.assign({}, png, jpg, jpeg, webp);

    const img = image?.split(".").shift();

    return Object.keys(obj)
        .map((val) => {
            if (val === img) {
                return !isCover ? <img key={val} src={obj[val]} alt={val} /> : obj[val];
            }
        })
        .filter(Boolean);
};

export default useDynamicImageGenerate;
